"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Longitude = (function () {
    function Longitude(lon) {
        this.lon = lon;
        if (lon < -180 || lon > 180) {
            throw new RangeError("Unable to construct Lon: value must be included in range -180 to 180 (Given: " + lon + ")");
        }
        this.lon = lon;
    }
    Longitude.prototype.toJSON = function () {
        return this.lon;
    };
    return Longitude;
}());
exports.Longitude = Longitude;
//# sourceMappingURL=Longitude.js.map